import * as React from 'react';

import PaperAirplane16 from './PaperAirplane16';

export const paperAirplane16 = () => <PaperAirplane16 />;

export default {
    title: 'Icon/Fill/PaperAirplane16',
    component: PaperAirplane16,
    parameters: {
        notes: "`import PaperAirplane16 from 'box-ui-elements/es/icon/fill/PaperAirplane16';`",
    },
};
